import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, X } from "lucide-react";
import { REVIEWS } from "@/lib/reviews";

export const ReviewPopup = () => {
  const [open, setOpen] = useState(false);
  const [review] = useState(() => REVIEWS[Math.floor(Math.random() * REVIEWS.length)]);

  useEffect(() => {
    if (sessionStorage.getItem("lvx_review")) return;
    const t = setTimeout(() => { setOpen(true); sessionStorage.setItem("lvx_review", "seen"); }, 9000);
    const h = setTimeout(() => setOpen(false), 17000);
    return () => { clearTimeout(t); clearTimeout(h); };
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 30 }}
                      data-testid="review-popup"
                      className="relative bg-[#0A0A0A] text-[#F4F2ED] border border-white/10 shadow-2xl max-w-xs p-5">
            <button onClick={() => setOpen(false)} data-testid="review-popup-close" className="absolute top-3 right-3 text-white/50 hover:text-white"><X size={15} /></button>
            <div className="flex gap-0.5 mb-2">
              {Array.from({ length: review.stars }).map((_, i) => <Star key={i} size={13} className="fill-[#F4F2ED] text-[#F4F2ED]" />)}
            </div>
            <p className="font-body text-sm leading-relaxed">"{review.text}"</p>
            <p className="overline mt-3 text-white/60">{review.name}{review.verified && " · Verified"}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
